/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetVariantDetailQueryResponse,
  GetVariantDetailPathParams,
  GetVariantDetail404,
} from '../../types/GetVariantDetail'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getVariantDetail } from '../../clients/getVariantDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getVariantDetailQueryKey = ({
  id,
}: {
  id: GetVariantDetailPathParams['id']
}) =>
  [
    { url: '/api/v1/products/catalog/variants/:id/', params: { id: id } },
  ] as const

export type GetVariantDetailQueryKey = ReturnType<
  typeof getVariantDetailQueryKey
>

export function getVariantDetailQueryOptions(
  { id }: { id: GetVariantDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getVariantDetailQueryKey({ id })
  return queryOptions<
    GetVariantDetailQueryResponse,
    ResponseErrorConfig<GetVariantDetail404>,
    GetVariantDetailQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getVariantDetail(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Get variant detail.
 * GET /variants/{pk}/
 * Args:
 * request: The request object
 * pk: Variant ID
 * Returns:
 * Response with variant data or error
 * @summary Get variant detail
 * {@link /api/v1/products/catalog/variants/:id/}
 */
export function useGetVariantDetail<
  TData = GetVariantDetailQueryResponse,
  TQueryData = GetVariantDetailQueryResponse,
  TQueryKey extends QueryKey = GetVariantDetailQueryKey,
>(
  { id }: { id: GetVariantDetailPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetVariantDetailQueryResponse,
        ResponseErrorConfig<GetVariantDetail404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getVariantDetailQueryKey({ id })

  const query = useQuery(
    {
      ...getVariantDetailQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetVariantDetail404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
